import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { Feature } from "../../models/feature.model";

export class FeatureExtraDialogController {
    // * bindings for typescript compiler *
    public feature: Feature;
    public isOrgCampaign: boolean;
    public openFeatureExtra: Function;
    // ************************************

    public isLeaderView: boolean;
    private readonly dialog: DialogUtils;

    constructor(DialogUtils: DialogUtils, __app_type: string) {
        this.dialog = DialogUtils;
        this.isLeaderView = __app_type == "LEADER";
    }

    confirm(): void {
        if (!this.validateExtraSettings(this.feature)) {
            this.openFeatureExtra(this.feature);
        } else {
            this.dialog.hide(this.feature);
        }
    }

    validateExtraSettings(feature: Feature): boolean {
        if (feature.index == "AUTO_GENERATE_VOTER_NAME") {
            return (
                feature.extra &&
                feature.extra != "" &&
                (feature.extra.defaultFirstName ||
                    feature.extra.firstNameAutoIncrement) &&
                (feature.extra.defaultFirstName != "" ||
                    feature.extra.firstNameAutoIncrement != "0") &&
                (feature.extra.defaultLastName ||
                    feature.extra.lastNameAutoIncrement) &&
                (feature.extra.defaultLastName != "" ||
                    feature.extra.lastNameAutoIncrement != "0")
            );
        }

        if (feature.index == "RECEPTION") {
            return (
                feature.extra &&
                feature.extra != "" &&
                feature.extra.veryLikely != "" &&
                feature.extra.likely != "" &&
                feature.extra.neutral != "" &&
                feature.extra.unlikely != "" &&
                feature.extra.veryUnlikely != "" &&
                feature.extra.ratingDescription != ""
            );
        }

        return true;
    }

    cancel(): void {
        this.dialog.cancel();
    }
}

angular
    .module("feature", [])
    .service("FeatureExtraDialogController", FeatureExtraDialogController);
